import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To get API authentication credentials and tokens, create an Adobe developer project to enable communication between your Commerce project and Merchandising Services APIs.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`To create Projects for enterprise organizations, you must have a system administrator or developer role with access to the `}<strong parentName="p">{`Adobe Commerce as a Cloud Service – Backend - Commerce Cloud Manager`}</strong>{` product. For information on managing developers from the Admin console, see `}<a parentName="p" {...{
        "href": "https://helpx.adobe.com/enterprise/using/manage-developers.html"
      }}>{`Managing developers`}</a>{` in the `}<em parentName="p">{`Adobe Enterprise & Teams Administration Guide`}</em>{`.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in to the `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/console"
          }}>{`Adobe Developer Console`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the Experience Cloud Organization for the integration.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create an API project.`}</p>
        <ol parentName="li">
          <li parentName="ol">
            <p parentName="li">{`Add the `}<strong parentName="p">{`Adobe Commerce Optimizer Ingestion`}</strong>{` API to your project. Then, click `}<strong parentName="p">{`Next`}</strong>{`.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Configure the Client ID and Client Secret credentials by selecting the `}<strong parentName="p">{`OAUTH Server to Server Authentication`}</strong>{` option.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<strong parentName="p">{`Save configured API`}</strong>{`.`}</p>
          </li>
        </ol>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the Connected Credentials section, view API configuration details by selecting `}<strong parentName="p">{`OAUTH Server-to-Server`}</strong>{`.`}</p>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.75000000000001%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/aad2e686213452775027df8977c5e70c/5530d/dev-console-credential-details.webp 320w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/0c8fb/dev-console-credential-details.webp 640w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/94b1e/dev-console-credential-details.webp 1280w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/0b34d/dev-console-credential-details.webp 1920w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/d5269/dev-console-credential-details.webp 2560w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/42ca8/dev-console-credential-details.webp 3000w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/aad2e686213452775027df8977c5e70c/dd4a7/dev-console-credential-details.png 320w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/0f09e/dev-console-credential-details.png 640w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/bbbf7/dev-console-credential-details.png 1280w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/ac7a9/dev-console-credential-details.png 1920w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/c7a69/dev-console-credential-details.png 2560w", "/commerce/services/static/aad2e686213452775027df8977c5e70c/49142/dev-console-credential-details.png 3000w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/commerce/services/static/aad2e686213452775027df8977c5e70c/bbbf7/dev-console-credential-details.png",
                "alt": "Adobe developer project - Credential Details",
                "title": "Adobe developer project - Credential Details",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy the Client ID and the Client Secret values to a secure location.`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Use the Client ID and Client Secret to refresh expired bearer tokens `}{`[using curl]`}{`.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Include the Client ID in the `}<inlineCode parentName="p">{`x-api-key`}</inlineCode>{` header to authenticate API requests.`}</p>
          </li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Get the bearer access token.`}</p>
        <ol parentName="li">
          <li parentName="ol">
            <p parentName="li">{`Select `}<strong parentName="p">{`Generate Access Token`}</strong>{`.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Save the bearer token to a secure location.`}</p>
          </li>
        </ol>
        <p parentName="li">{`The bearer token is valid for 24 hours. You can use the same bearer token for all API requests until it expires.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      